import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "eyeOpenedFilled"
const EyeOpenedFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 7.5C14.071 7.5 15.75 9.179 15.75 11.25S14.071 15 12 15 8.25 13.321 8.25 11.25 9.929 7.5 12 7.5" />
          <path
            fillRule="evenodd"
            d="M12 3.75C18.75 3.75 22.5 11.25 22.5 11.25S18.75 18.75 12 18.75 1.5 11.25 1.5 11.25 5.25 3.75 12 3.75M12 5.25C9.211 5.25 6.953 6.8 5.306 8.533 4.494 9.388 3.87 10.248 3.45 10.896Q3.325 11.087 3.226 11.25 3.326 11.413 3.45 11.604C3.869 12.253 4.494 13.113 5.306 13.968 6.953 15.7 9.211 17.25 12 17.25S17.047 15.7 18.694 13.967C19.506 13.112 20.13 12.252 20.55 11.604Q20.675 11.414 20.773 11.25 20.674 11.087 20.55 10.896C20.131 10.248 19.506 9.388 18.694 8.533 17.047 6.8 14.789 5.25 12 5.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EyeOpenedFilledIcon
